export type PortalPersonalProfile = {
  displayName: string;
  avatarUrl?: string | null;
  account: string;
  roleName: string;
  organizationName: string;
  departmentName: string;
  tenantName: string;
  tenantCode: string;
  tenantStatus: string;
  accountStatus: string;
  email: string;
  mobile: string;
  passwordConfigured: boolean;
};

export type ChangePasswordRequest = {
  currentPassword?: string;
  newPassword: string;
};

export const PASSWORD_MIN_LENGTH = 6;

export function passwordLengthValid(value: string) {
  return value.length >= PASSWORD_MIN_LENGTH && value.length <= 128;
}
